<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <!-- <div class="columns">
            <div class="column is-12">
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a>Super Admin</a>
                        </li>
                        <li class="is-active">
                            <a href="#" aria-current="page">Home</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div> -->
        <div class="columns">
            <div class="column is-2"><button class="button is-medium is-fullwidth is-primary">Class</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth">Students</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth">Teachers</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth">Behavior</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth">Notification</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth">Badges</button></div> -->
        </div>
        
        <div class="columns column is-12">
            <div class="card is-hidden1">
                <div class="card-header">
                    <p class="card-header-title">Badges</p>
                    <a class="button is-primary" v-on:click="addContentForm()" style="margin: 5px;" v-show="!addContent">Add A Class</a>
                    <a class="button is-warning" v-on:click="closeAddContentForm()" style="margin: 5px" v-show="addContent">Close Add Class</a>
                </div>
                <div class="card-content">
                
                    <!-- <div class="content" v-show="addContent">                                    
                        <add-content></add-content>
                    </div>
                    <loading :active.sync="isLoading" 
                        :can-cancel="false" 
                        :is-full-page="true">
                    </loading>
                    <div><data-list v-bind:dataList="dataList" class="columns is-multiline"></data-list></div>                                        -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
const helper = require("../../config/helper")

export default {
    name: "SuperHome",
    components: {
        NewTopMenu
    },
    data() {
        return {
            height: 0,
            superId: "",
            superEmail: "",
            schoolCount: 0,
            classCount: 0,
            teacherCount: 0,
            studentCount: 0,
            listLatestSchool: [],
            listTrialSchool: [],  //list schools with 1 month unlimited trial that wil expire soon
            listRequestPlanChange: [],
            isActive: true
        };
    },
    created() {
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
    }
};
</script>

<style scoped>
.container{
    padding: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Manage.vue